import React, { useContext } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { FaArrowRight, FaStar } from 'react-icons/fa';
import { mainImageURI } from './assets/constants/Urls/Url';
import "./NewCollections/NewCollections.css";
import Card from './Card/Card';

// Create a context (move this to a separate file if you want global access)
export const ProductRowBgContext = React.createContext('transparent');

const MAX_NAME_LENGTH = 28; // Adjust as needed for your card width

const ProductRow = ({
  title,
  products = [],
  isLoading = false,
  error = null,
  seeAllLink = '',
}) => {
  const navigate = useNavigate();
  const productRowBg = useContext(ProductRowBgContext); // Get background from context

  const handleCardClick = (id) => {
    if (id) {
      navigate(`/product/${id}`);
    } else {
      console.error("Invalid product ID:", id);
    }
  };

  const truncate = (str, n) =>
    str && str.length > n ? str.slice(0, n - 1) + "…" : str;

  if (isLoading) {
    return (
      <div className="loading-container container">
        <div className="row-block">
          {Array.from({ length: 6 }).map((_, index) => (
            <div className="card1f h-100" key={index}>
              <div className="skeleton-card card h-100">
                <div className="skeleton-image"></div>
                <div className="skeleton-text"></div>
                <div className="skeleton-text short"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="error-container container">
        <p>Error: {error.message || "Network Error"}</p>
      </div>
    );
  }

  return (
    <div
      className="container new-collections-section"
      style={{ background: productRowBg, paddingBottom: '2rem' }}
    >
      <div className="c-text-Wraper" >
        <h1 className="text-start">{title}</h1>
        {seeAllLink && (
          <Link to={seeAllLink} className="see-all">
            <FaArrowRight size={24} />
          </Link>
        )}
      </div>
      <hr className="mb-4 hr" />
      <div className="row-block no-horizontal-scroll">
        {products.map((item) => (
          <Card
          item={item}
          />
        ))}
      </div>
    </div>
  );
};

export default ProductRow;
